import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const initialRole = params.get("role") === "commerce" ? "commerce" : "client";
  const [role, setRole] = useState(initialRole);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, role });
      setSent(true);
      toast.success("Un email vous a été envoyé");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="container mx-auto px-4 md:px-8 py-16 max-w-md text-center">
        <p className="overline mb-2">Réinitialisation</p>
        <h1 className="font-display text-3xl font-black tracking-tight text-ink">Email envoyé</h1>
        <p className="mt-4 text-subtle">
          Si un compte existe pour <strong>{email}</strong>, un email de réinitialisation vient d'être envoyé. Vérifiez votre boîte mail — le lien est valide <strong>30 minutes</strong> et à usage unique.
        </p>
        <p className="mt-3 text-xs text-subtle">
          Pensez à vérifier vos spams si vous ne voyez rien arriver.
        </p>
        <Button onClick={() => nav("/login")} className="mt-8 h-12 bg-brand hover:bg-brand-hover rounded-md text-white px-8" data-testid="back-login-btn">
          Retour à la connexion
        </Button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 md:px-8 py-16 max-w-md">
      <Link to="/login" className="text-sm text-subtle hover:text-ink" data-testid="back-login-link">← Connexion</Link>
      <p className="overline mb-2 mt-4">Réinitialisation</p>
      <h1 className="font-display text-3xl font-black tracking-tight text-ink">Mot de passe oublié</h1>
      <p className="mt-2 text-subtle">Entrez votre email, nous vous enverrons un lien sécurisé pour créer un nouveau mot de passe.</p>

      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
        <div>
          <Label>Type de compte</Label>
          <div className="mt-1.5 grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setRole("client")} className={`h-11 text-sm font-medium border-2 ${role === "client" ? "border-brand bg-brand/5 text-brand" : "border-border text-subtle"}`} data-testid="role-client-btn">Visiteur</button>
            <button type="button" onClick={() => setRole("commerce")} className={`h-11 text-sm font-medium border-2 ${role === "commerce" ? "border-ink bg-ink/5 text-ink" : "border-border text-subtle"}`} data-testid="role-commerce-btn">Établissement</button>
          </div>
        </div>
        <div>
          <Label>Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 mt-1.5" data-testid="email-input" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-12 bg-brand hover:bg-brand-hover rounded-md text-white font-medium" data-testid="submit-btn">
          {loading ? "…" : "Envoyer le lien de réinitialisation"}
        </Button>
      </form>
    </div>
  );
}
